import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Box,
  Typography,
  CircularProgress,
  Container,
  Button,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { baseUrl } from "../../helper/urls";
import BlogNavbar from "./BlogNavbar";

export default function BlogDetails() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogDetails = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/api/blog/getBlogDetails/${slug}`
        );
        setBlog(response.data.data);
      } catch (error) {
        console.error("Error fetching blog details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogDetails();
  }, [slug]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="60vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!blog) {
    return (
      <Box textAlign="center" mt={5}>
        <Typography variant="h6" color="error">
          Blog not found.
        </Typography>
        <Button
          onClick={() => navigate(-1)}
          startIcon={<ArrowBackIcon />}
          sx={{ mt: 2 }}
        >
          Go Back
        </Button>
      </Box>
    );
  }

  return (
    <>
      {/* <Container maxWidth="xl" sx={{ mt: 4 }}> */}
      <Box sx={{ p: 3 }}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{ mb: 3 }}
        >
          Back
        </Button>

        {/* <Box textAlign="center" mb={3}>
          <img
            src={`${baseUrl}${blog.image_url}`}
            alt={blog.title}
            style={{
              maxWidth: "100%",
              height: "auto",
              borderRadius: 8,
            }}
          />
        </Box> */}

        {/* <Typography variant="h4" gutterBottom align="center">
          {blog.title}
        </Typography> */}

        {/* <Typography
          variant="body1"
          sx={{ whiteSpace: "pre-line" }}
          align="center"
        >
          {blog.description}
        </Typography> */}

        <Box
          sx={{
            maxWidth: "100%",
            overflow: "hidden",
            wordBreak: "break-word",
            padding: 2,
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: blog.content }} />
        </Box>

        {/* <div
          dangerouslySetInnerHTML={{ __html: blog.content }}
          style={{ marginTop: 24, lineH eight: 1.6 }}
        /> */}
      </Box>
      {/* </Container> */}
    </>
  );
}
